import { skipToken } from '@reduxjs/toolkit/query';
import CheckboxInput from 'components/forms/inputs/rhf-inputs/CheckboxInput';
import { useWatch } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { useGetPracticeAreasWithFiltersNotPaginatedQuery } from 'store/api/practice-areas';
import { PracticeAreaType } from 'types/practice-areas';
import { t } from 'utils/getTranslations';
import { PracticeAreaFormState } from './usePracticeAreaForm';

/** Offered on a saved main practice area with subareas while its exclusion from automatic closing is ticked. */
export const ApplyExclusionToSubareasField = ({ form }: { form: PracticeAreaFormState }): JSX.Element | null => {
    const { id: practiceAreaId } = useParams();
    const { control } = form.methods;
    const isExcludedFromAutomaticClosing = useWatch({ control, name: 'isExcludedFromAutomaticClosing' });
    const isMainPracticeArea = form.practiceAreaType === PracticeAreaType.PRACTICE_AREA;
    const { data: subareas = [] } = useGetPracticeAreasWithFiltersNotPaginatedQuery(
        practiceAreaId && isMainPracticeArea
            ? { filters: `parentPracticeArea.id==${Number(practiceAreaId)}`, sort: 'name,asc' }
            : skipToken
    );

    if (!isExcludedFromAutomaticClosing || !isMainPracticeArea || subareas.length === 0) {
        return null;
    }
    return (
        <div className="border-grey-300 ml-2 flex flex-col gap-1 border-l pl-5">
            <CheckboxInput
                control={control}
                name="applyExclusionToSubareas"
                label={t('case-closing-practice-area.apply-to-subareas', { count: String(subareas.length) })}
                shouldTranslateLabel={false}
            />
            <p className="text-fg-secondary text-sm">{subareas.map((subarea) => subarea.name).join(' · ')}</p>
            <p className="text-fg-secondary text-xs">{t('case-closing-practice-area.apply-to-subareas-helper')}</p>
        </div>
    );
};
